export default __webpack_public_path__ + "static/media/financed_eu_Logo.5e33cad3.svg";